import {
    widgetDropdownCategory,
    WidgetDropdownCategory,
} from 'widgets/WidgetCategory';
import { WidgetDropdownItem } from 'widgets/WidgetsService';
import { useCategorisedWidgets } from 'widgets/hooks';
import { WidgetCategory } from 'widgets/WidgetCategory';

export function useAddWidgetData(): Array<{
    category: WidgetDropdownCategory;
    options: WidgetDropdownItem[];
}> {
    const dropdownCategories = [
        widgetDropdownCategory(WidgetCategory.TOP),
        widgetDropdownCategory(WidgetCategory.SINGLE_STOCK),
        widgetDropdownCategory(WidgetCategory.MULTIPLE_STOCK),
        widgetDropdownCategory(WidgetCategory.PORTFOLIO),
    ];

    return useCategorisedWidgets('layout', dropdownCategories);
}
